import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const TalentManagement = React.lazy(() =>
  import("@/pages/talentManagement/index")
);

const TalentManagementRouter = [
  {
    path: "talentManagement",
    element: (
      <SuspenseWrapper>
        <TalentManagement />
      </SuspenseWrapper>
    ),
  },
];

export default TalentManagementRouter;
